import { render, staticRenderFns } from "./MessageDelayInput.vue?vue&type=template&id=63006c50"
import script from "./MessageDelayInput.vue?vue&type=script&lang=js"
export * from "./MessageDelayInput.vue?vue&type=script&lang=js"
import style0 from "./MessageDelayInput.vue?vue&type=style&index=0&id=63006c50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports